<template>
  <ReportViewerTab :reports="horse.reports" />
</template>
<script>
import ReportViewerTab from "@elements/ReportViewerTab.vue";
export default {
  name: "HorseReports",
  components: { ReportViewerTab },
  props: {
    horse: {
      type: Object,
      required: true
    }
  },
  fragments: ReportViewerTab.fragments
};
</script>
